import React from "react";
import styled, { css } from "styled-components";

const defaultCss = css`
  line-height: 1;
  font-size: 15px;
  font-weight: 400;
  margin: 0;
  word-break: normal;
  color: #293041;

  ${(props) => props.withIcon && "display: flex; align-items: center;"};
  word-break: normal;
  text-align: center;
  font-family: Heebo;
`;

const DefaultText = styled.label`
  ${defaultCss};
`;

const Error = styled(DefaultText)`
  color: red;
`;

const Heading = styled(DefaultText)(({ color, ...props }) => ({
  margin: "0.2rem 0",
  fontWeight: 600,
  color: color || props.theme.color.text,
}));

const Heading1 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: props.theme.fontSize?.heading1,
}));

const Heading2 = styled(Heading)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.heading2,
}));

const Heading3 = styled(Heading)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.heading3,
}));

const Heading4 = styled(Heading)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.heading4,
}));

const Text1 = styled(DefaultText)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.text1,
}));

const Text2 = styled(DefaultText)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.text2,
}));

const Text3 = styled(DefaultText)(({ ...props }) => ({
  fontWeight: 600,
  fontSize: props.theme.fontSize?.text3,
}));

const Text4 = styled(DefaultText)(({ ...props }) => ({
  fontSize: props.theme.fontSize?.text4,
}));

const TextFactory = ({ variant, theme, color, ...props }) => {
  const vars = {
    h1: <Heading1 color={color} {...props} />,
    h2: <Heading2 color={color} {...props} />,
    h3: <Heading3 color={color} {...props} />,
    h4: <Heading4 color={color} {...props} />,
    t1: <Text1 color={color} {...props} />,
    t2: <Text2 color={color} {...props} />,
    t3: <Text3 color={color} {...props} />,
    t4: <Text4 color={color} {...props} />,

    error: <Error {...props} />,
  };
  return vars[variant] || <DefaultText {...props} />;
};

const Text = ({ v, color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);

Text.H1 = ({ v = "h1", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H2 = ({ v = "h2", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H3 = ({ v = "h3", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H4 = ({ v = "h4", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.T1 = ({ v = "t1", color, ...props }) => (
  <TextFactory {...props} variant={v} />
);
Text.T2 = ({ v = "t2", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.T3 = ({ v = "t3", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.T4 = ({ v = "t4", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);

Text.Error = ({ v = "error", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);

Text.H1.displayName = "Heading1";
Text.H2.displayName = "Heading2";
Text.H3.displayName = "Heading3";
Text.H4.displayName = "Heading4";
Text.T1.displayName = "Text1";
Text.T2.displayName = "Text2";
Text.T3.displayName = "Text3";
Text.T4.displayName = "Text4";

Text.Error.displayName = "Error";

export default Text;
